import Box from "@mui/material/Box";
import { useState } from "react";
import { useVideo } from "../../../../context/juno/VideoContext";
import { useVideoGeneration } from "../../../../hooks/useVideoGeneration";
import ProPlanModal from "../../../../components/common/ProPlanModal";
import VideoPromptInput from "./VideoPromptInput";
import { alpha } from "@mui/material/styles";

interface InputPromptProps {
  onSuccess?: () => void;
}

const InputPrompt: React.FC<InputPromptProps> = ({ onSuccess }) => {
  const { prompt, setPrompt } = useVideo();
  const [openProDialog, setOpenProDialog] = useState(false);

  const {
    updating,
    totalCredit,
    isCalculatingVideoCredit,
    isCalculatingSoundCredit,
    disable3sec,
    rotationDegree,
    generateSampleText,
    handleSubmit,
  } = useVideoGeneration(onSuccess);

  const handleGenerateSample = () => {
    generateSampleText(setPrompt);
  };

  const handleSubmitClick = () => {
    handleSubmit(prompt, setPrompt, setOpenProDialog);
  };

  return (
    <Box
      sx={{
        backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.5),
        borderRadius: 2,
        p: 2,
      }}
    >
      <VideoPromptInput
        updating={updating}
        rotationDegree={rotationDegree}
        onGenerateSample={handleGenerateSample}
        onSubmit={handleSubmitClick}
        disable3sec={disable3sec}
        totalCredit={totalCredit}
        isCalculatingVideoCredit={isCalculatingVideoCredit}
        isCalculatingSoundCredit={isCalculatingSoundCredit}
      />
      <ProPlanModal open={openProDialog} setOpen={setOpenProDialog} />
    </Box>
  );
};

export default InputPrompt;
